import React from 'react';
import { Segmented } from 'antd';
import { AreaChartOutlined, TableOutlined } from '@ant-design/icons';
import { StyledHeader } from '../../styled';
import type { CommonTypes } from '../helpers';

type VisualType = 'stacked' | 'treemap';
interface HeaderProps extends CommonTypes {
  title: string;
  value: VisualType;
  validate: {
    stacked: boolean;
    treemap: boolean;
    enableMetricFilter: boolean;
  };
  onChange: (type: VisualType) => void;
}

function Header({ title, value, onChange, validate }: HeaderProps) {
  const { stacked, enableMetricFilter } = validate;
  return (
    <StyledHeader>
      <h4>{title}</h4>
      <div>
        <Segmented
          options={[
            {
              label: (
                <div>
                  <AreaChartOutlined />
                </div>
              ),
              value: 'stacked',
              disabled: !stacked && enableMetricFilter
            },
            {
              label: (
                <div>
                  <TableOutlined />
                </div>
              ),
              value: 'treemap'
            },
          ]}
          value={value}
          onChange={onChange as (p: any) => void}
        />
      </div>
    </StyledHeader>
  )
}

export default Header;
